import React, { useState } from 'react';
import RelaysTwoUpdate from "./RelaysTwoUpdate";
import CreateReport from "./CreateReport";
import './RelaysOne.css';
import { API_URL } from './API';

function RelayInspectionForm({ block, plant, instrument, project, goBack, reportToUpdate, isUpdateMode }) {
  const [showNextPage, setShowNextPage] = useState(false);
  const [showBackPage, setShowBackPage] = useState(false);
  
  const [formData, setFormData] = useState(() => {
    try {
      
      if (isUpdateMode && reportToUpdate?.test_data) {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          try { testData = JSON.parse(testData); } catch {}
        }
        const maybeForm = testData.relayGeneralData || testData.formData || testData.a_formData || {};
        const flat = {};
        Object.keys(maybeForm || {}).forEach(key => {
          const val = maybeForm[key];
          if (val && typeof val === 'object') {
            const values = Object.values(val);
            flat[key] = values.length > 0 ? values[0] : '';
          } else {
            flat[key] = val ?? '';
          }
        });
        return {
          description: 'NUMERICAL RELAY INSPECTION / TEST REPORT',
          date: '',
          customer: '',
          project: '',
          reportNo: '',
          location: '',
          client: '',
          make: '',
          type: '',
          serialNo: '',
          supplyVoltage: '',
          ctRatio: '',
          phaseRMeasured: '',
          phaseYMeasured: '',
          phaseBMeasured: '',
          ...flat
        };
      }

      
      const savedData = localStorage.getItem('updateRelayInspectionData');
      if (savedData) return JSON.parse(savedData);

      
      return {
        description: 'NUMERICAL RELAY INSPECTION / TEST REPORT',
        date: '',
        customer: '',
        project: '',
        reportNo: '',
        location: '',
        client: '',
        make: '',
        type: '',
        serialNo: '',
        supplyVoltage: '',
        ctRatio: '',
        phaseRMeasured: '',
        phaseYMeasured: '',
        phaseBMeasured: '',
      };
    } catch (e) {
     
      return {
        description: 'NUMERICAL RELAY INSPECTION / TEST REPORT',
        date: '',
        customer: '',
        project: '',
        reportNo: '',
        location: '',
        client: '',
        make: '',
        type: '',
        serialNo: '',
        supplyVoltage: '',
        ctRatio: '',
        phaseRMeasured: '',
        phaseYMeasured: '',
        phaseBMeasured: '',
      };
    }
  });

  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});

  React.useEffect(() => {
    try {
      
      localStorage.setItem('updateRelayInspectionData', JSON.stringify(formData));
    } catch {}
  }, [formData]);

  
  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = [];
        
        if (Array.isArray(result)) {
          clientsData = result;
        } else if (result.data && Array.isArray(result.data)) {
          clientsData = result.data;
        } else if (result.clients && Array.isArray(result.clients)) {
          clientsData = result.clients;
        }
        
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
      
    }
    return "Unknown Client";
  };

 
  React.useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
       
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setFormData(prevData => ({
          ...prevData,
          project: project?.name || '',
          client: clientName || ''
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

  const validateInput = (name, value) => {
    switch (name) {
      case 'description':
        return value.replace(/[^a-zA-Z \s/]/g, '');

      case 'customer':
      case 'client':
        return value.replace(/[^a-zA-Z \s]/g, '');

      case 'project':
        return value.replace(/[^a-zA-Z0-9, ]/g, '');
      
      case 'reportNo':
      case 'location':
        return value.replace(/[^a-zA-Z0-9-, ()]/g, '');
      
      case 'make':
        return value.replace(/[^a-zA-Z0-9 ]/g, '');
      
      case 'type':
      case 'supplyVoltage':
      case 'serialNo':
        return value.replace(/[^a-zA-Z0-9/, ]/g, '');
      
      case 'ctRatio':
        return value.replace(/[^a-zA-Z0-9 /]/g, '');

      case 'phaseRMeasured':
      case 'phaseYMeasured':
      case 'phaseBMeasured':
        return value.replace(/[^0-9.]/g, '');
      
      default:
        return value;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validatedValue = validateInput(name, value);
    setFormData(prev => {
      const next = { ...prev, [name]: validatedValue };
      try { localStorage.setItem('updateRelayInspectionData', JSON.stringify(next)); } catch {}
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    localStorage.setItem('updateRelayInspectionData', JSON.stringify(formData));
  };
  
  const handleBack = () => {
    localStorage.setItem('updateRelayInspectionData', JSON.stringify(formData));
    setShowBackPage(true);
    window.location.reload();
  };
  
  const handleNext = (e) => {
    e.preventDefault();
    localStorage.setItem('updateRelayInspectionData', JSON.stringify(formData));
    setShowNextPage(true);
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  if (showBackPage) {
    return <CreateReport goBack={() => setShowBackPage(false)} savedGeneralFormData={formData} />;
  }

  if (showNextPage) {
    return <RelaysTwoUpdate 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection
      }} 
    />;
  }
  
  
  return (
    <div className="ct-1023">
      <form onSubmit={handleSubmit}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className="ct-1025">NUMERICAL RELAY INSPECTION / UPDATE TEST REPORT</h2>

        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
        </div>

        <div className="ct-1026 ct-1027">
          <div className="ct-1028">Report Details</div>
          <div className="ct-1029">
            <div className="ct-1030">
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Description</label>
                </div>
                <input
                  type="text"
                  name="description"
                  value='NUMERICAL RELAY INSPECTION / TEST REPORT'
                  onChange={handleChange}
                  placeholder="Enter Description"
                  required
                  maxLength={40}
                  className="ct-1034"
                  readOnly={"description"}
                  style={"description" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
                />
              </div>
              
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Date</label>
                </div>
                <input 
                  type="date" 
                  name="date"
                  placeholder="Select Date" 
                  value={formData.date || ''}
                  onChange={handleChange}
                  className="ct-1034"
                />
              </div>
              
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Customer</label>
                </div>
                <input
                  type="text"
                  name="customer"
                  value={formData.customer || ''}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Enter Customer"
                  required
                  className="ct-1034"
                />
              </div>
            </div>
            
            <div className="ct-1030">
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Project</label>
                </div>
                <input
                  type="text"
                  name="project"
                  value={formData.project || ''}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Enter Project"
                  required
                  className="ct-1034"
                  readOnly={"project"}
                  style={"project" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
                />
              </div>
              
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Report No</label>
                </div>
                <input
                  type="text"
                  name="reportNo"
                  value={formData.reportNo || ''}
                  maxLength={40}
                  onChange={handleChange}
                  placeholder="Enter Report"
                  required
                  className="ct-1034"
                />
              </div>
              
              <div className="ct-1031">
                <div className="ct-1032">
                  <label>Location</label>
                </div>
                <input
                  type="text"
                  name="location"
                  value={formData.location || ''}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Enter Location"
                  required
                  className="ct-1034"
                 
                  
                />
              </div>
            </div>
            
            <div className="ct-1030">
              <div className="ct-1031 ct-1035">
                <div className="ct-1032">
                  <label>Client</label>
                </div>
                <input
                  type="text"
                  name="client"
                  value={formData.client || ''}
                  maxLength={40}
                  onChange={handleChange}
                  placeholder="Enter Client"
                  required
                  className="ct-1034"
                  readOnly={"client"}
                  style={"client" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="ct-1036">
          <div className="ct-1037">
            <div className="ct-1026">
              <div className="ct-1028">Name Plate Details</div>
              <div className="ct-1029">
                <div className="ct-1038">
                  <div className="ct-1032">
                    <label>Make</label>
                  </div>
                  <input
                    type="text"
                    name="make"
                    value={formData.make || ''}
                    maxLength={40}
                    onChange={handleChange}
                    placeholder="Enter Make"
                    required
                    className="ct-1034"
                  />
                </div>
                
                <div className="ct-1038">
                  <div className="ct-1032">
                    <label>Type</label>
                  </div>
                  <input
                    type="text"
                    name="type"
                    value={formData.type || ''}
                    onChange={handleChange}
                    maxLength={40}
                    placeholder="Enter Type"
                    required
                    className="ct-1034"
                  />
                </div>
                
                <div className="ct-1038">
                  <div className="ct-1032">
                    <label>Serial No</label>
                  </div>
                  <input
                    type="text"
                    name="serialNo"
                    value={formData.serialNo || ''}
                    maxLength={40}
                    onChange={handleChange}
                    placeholder="Enter Serial No"
                    required
                    className="ct-1034"
                  />
                </div>
                
                <div className="ct-1038">
                  <div className="ct-1032">
                    <label>Supply Voltage(Uaux)</label>
                  </div>
                  <input
                    type="text"
                    name="supplyVoltage"
                    value={formData.supplyVoltage || ''}
                    maxLength={40}
                    onChange={handleChange}
                    placeholder="Enter Supply Voltage(Uaux)"
                    required
                    className="ct-1034"
                  />
                </div>
                
                <div className="ct-1038">
                  <div className="ct-1032">
                    <label>CT Ratio</label>
                  </div>
                  <input
                    type="text"
                    name="ctRatio"
                    value={formData.ctRatio || ''}
                    maxLength={40}
                    onChange={handleChange}
                    placeholder="Enter CT Ratio"
                    required
                    className="ct-1034"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div className="ct-1037">
            <div className="ct-1026">
              <div className="ct-1028">Current Transformer Measurements</div>
              <div className="ct-1029">
                <div className="ct-1039">
                  <div className="ct-1040">
                    <div className="ct-1041 ct-1042">
                      <div className="ct-1032">
                        <label>Phase</label>
                      </div>
                    </div>
                    <div className="ct-1041 ct-1043">
                      <div className="ct-1032">
                        <label>Injected Current(Amp)</label>
                      </div>
                    </div>
                    <div className="ct-1041 ct-1044">
                      <div className="ct-1032">
                        <label>Measured Current(Amp)</label>
                      </div>
                    </div>
                  </div>
                  
                  <div className="ct-1045">
                    <div className="ct-1046">
                      <div className="ct-1047">R</div>
                      <div className="ct-1048">1</div>
                      <input
                        type="text"
                        name="phaseRMeasured"
                        value={formData.phaseRMeasured || ''}
                        maxLength={10}
                        onChange={handleChange}
                        placeholder="Enter Measured Current"
                        className="ct-1049"
                        required
                      />
                    </div>
                    
                    <div className="ct-1046">
                      <div className="ct-1047">Y</div>
                      <div className="ct-1048">1</div>
                      <input
                        type="text"
                        name="phaseYMeasured"
                        value={formData.phaseYMeasured || ''}
                        maxLength={10}
                        onChange={handleChange}
                        placeholder="Enter Measured Current"
                        className="ct-1049"
                        required
                      />
                    </div>
                    
                    <div className="ct-1046">
                      <div className="ct-1047">B</div>
                      <div className="ct-1048">1</div>
                      <input
                        type="text"
                        name="phaseBMeasured"
                        value={formData.phaseBMeasured || ''}
                        maxLength={10}
                        onChange={handleChange}
                        placeholder="Enter Measured Current"
                        className="ct-1049"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="ct-1050">
          <button type="button" onClick={goBack} className="ct-1051">Back</button>
          <button type="button" onClick={handleNext} className="ct-1051">Next</button>
        </div>
      </form>
    </div>
  );
}

export default RelayInspectionForm;